import { Clear } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { StyledEspecialidadCard } from "../../../styled/form";

const EspecialidadesCard = ({ especialidades, disabled, handleDelete }) => {
  const especialidadesState = useSelector(
    (state) => state.forms.specialtiesDiagnosis,
  );

  const getEspecialidad = (id) => {
    const e = especialidadesState.data.find((p) => p.id === id);
    return e ? e.especialidad : undefined;
  };

  const getDiagnostico = (id) => {
    const e = especialidadesState.data.find((p) => p.id === id);
    return e ? e.diagnostico : undefined;
  };

  return (
    <StyledEspecialidadCard.Container>
      {especialidades.map((especialidad) => (
        <StyledEspecialidadCard.Card
          key={especialidad.idEspecialidadDiagnosticoOms}>
          <StyledEspecialidadCard.InfoContainer elevation={2}>
            <div>
              <Typography>
                <b>Especialidad: </b>
                {getEspecialidad(especialidad.idEspecialidadDiagnosticoOms)}
              </Typography>
              <Typography>
                <b>Diagnóstico: </b>
                {getDiagnostico(especialidad.idEspecialidadDiagnosticoOms)}
              </Typography>
              <StyledEspecialidadCard.RowContainer>
                <Typography>
                  <b>Mismo centro: </b> {especialidad.turno ? "Si" : "No"}
                </Typography>
                {especialidad.turno && (
                  <Typography>
                    <b>Fecha de turno: </b>
                    {moment(especialidad.turno).format("DD/MM/YYYY")}
                  </Typography>
                )}
              </StyledEspecialidadCard.RowContainer>
            </div>
          </StyledEspecialidadCard.InfoContainer>
          <StyledEspecialidadCard.ActionContainer elevation={2}>
            {disabled ? (
              <StyledEspecialidadCard.DisabledButton title="Eliminar">
                <Clear />
              </StyledEspecialidadCard.DisabledButton>
            ) : (
              <Button
                title="Eliminar"
                onClick={() => handleDelete(especialidad)}>
                <Clear />
              </Button>
            )}
          </StyledEspecialidadCard.ActionContainer>
        </StyledEspecialidadCard.Card>
      ))}
    </StyledEspecialidadCard.Container>
  );
};

export default EspecialidadesCard;
